export default __webpack_public_path__ + "static/media/1.96916f0a.jpg";